import { render, staticRenderFns } from "./UserFormPassword.vue?vue&type=template&id=46f163bc"
import script from "./UserFormPassword.vue?vue&type=script&lang=js"
export * from "./UserFormPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46f163bc')) {
      api.createRecord('46f163bc', component.options)
    } else {
      api.reload('46f163bc', component.options)
    }
    module.hot.accept("./UserFormPassword.vue?vue&type=template&id=46f163bc", function () {
      api.rerender('46f163bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/User/Form/UserFormPassword.vue"
export default component.exports